import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DepotActions } from '../+state/depot.actions';
import { depotFeature } from '../+state/depot.reducer';

@Injectable({ providedIn: 'root' })
export class DepotFacade {
  readonly #store: Store = inject(Store);

  public readonly savingsPlanTeaserProducts$ = this.#store.select(depotFeature.selectTeaserProducts);
  public readonly savingsPlanTeaserProductsIgnoreInterest$ = this.#store.select(depotFeature.selectTeaserProductsIgnoreInterest);
  public readonly error$ = this.#store.select(depotFeature.selectError);
  public readonly displayDirectDebitHint$ = this.#store.select(depotFeature.selectDisplayDirectDebitHint);
  public readonly cryptoWalletInterested$ = this.#store.select(depotFeature.selectCryptoWalletInterested);
  public readonly dividendReinvestHint$ = this.#store.select(depotFeature.selectDividendReinvestHint);
  public readonly dividendReceivedHint$ = this.#store.select(depotFeature.selectDividendReceivedHint);

  public loadUserInterests(): void {
    this.#store.dispatch(DepotActions.loadUserInterests());
  }

  public dismissSavingsPlanTeaser(): void {
    this.#store.dispatch(DepotActions.dismissSavingsPlanTeaser());
  }

  public setCryptoWalletInterested(interested: boolean): void {
    this.#store.dispatch(DepotActions.setCryptoWalletInterested({ interested }));
  }

  public activateDirectDebit(): void {
    this.#store.dispatch(DepotActions.activateDirectDebit());
  }
}
